<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Simulado</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text :disabled="!selected_mock" @click="print()">
            <v-icon left style="left: 12px; margin: unset">printer</v-icon>
            Imprimir simulado
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container id="print" v-if="selected_mock">
        <div
          class="only-print title-print"
          style="justify-content: center; display: flex"
        >
          <a
            :href="mock_url"
            style="
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              align-items: center;
            "
          >
            <h3
              style="flex-basis: 100%; text-align: center; margin-bottom: 4px"
            >
              {{ selected_mock.description || "Questões" }}
            </h3>
            <qrcode-vue
              :value="mock_url"
              render-as="svg"
              level="H"
              style="display: flex; width: fit-content"
            />
          </a>
        </div>
        <v-list>
          <v-list-item
            style="page-break-inside: avoid"
            v-for="(question, index) in selected_mock.questions.data"
            :key="index"
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                <h3 style="font-weight: 500; font-size: 14px">
                  {{ question.identifier }} - {{ question.topic }}
                </h3>
              </v-list-item-subtitle>
              <v-list-item-title
                class="question-title"
                style="
                  line-break: auto;
                  text-overflow: unset;
                  white-space: normal;
                  display: flex;
                "
              >
                <div style="width: calc(100% - 110px); padding-right: 10px">
                  <p v-html="question.statement"></p>
                </div>
                <a
                  :href="`${base_url}/mocks/new?limit=50&neverSolved=false&mode=1&questionId=${question.id}`"
                >
                  <qrcode-vue
                    :value="`${base_url}/mocks/new?limit=50&neverSolved=false&mode=1&questionId=${question.id}`"
                    render-as="svg"
                    level="H"
                    style="display: flex; width: fit-content"
                  />
                </a>
              </v-list-item-title>
              <v-list-item-subtitle class="question-alternative">
                <b>A) </b>{{ question.option_1 }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="question-alternative">
                <b>B) </b>{{ question.option_2 }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="question-alternative">
                <b>C) </b>{{ question.option_3 }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="question-alternative">
                <b>D) </b>{{ question.option_4 }}
              </v-list-item-subtitle>
              <v-list-item-subtitle
                class="question-alternative"
                v-if="question.option_5"
              >
                <b>E) </b>{{ question.option_5 }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-container>
      <v-layout
        v-else
        style="justify-content: center; height: 90vh; align-items: center"
      >
        <v-progress-circular indeterminate />
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
// para usar logo https://github.com/Binaryify/vue-qr
import QrcodeVue from "qrcode.vue";
export default {
  components: {
    QrcodeVue,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    autoPrint: {
      type: Boolean,
      default: false,
    },
    selected_mock: {
      type: Object,
      default: null,
    },
  },
  computed: {
    base_url() {
      return window.location.origin;
    },
    mock_url() {
      if (this.selected_mock && this.selected_mock.id != 0) {
        return `${this.base_url}/mocks/${this.selected_mock.id}`;
      } else {
        return window.location.href;
      }
    },
  },
  watch: {
    dialog: function (newVal, oldVal) {
      // when the print dialog is opened, print the content
      if (!oldVal && newVal && this.autoPrint) {
        setTimeout(() => {
          this.print();
        }, 500);
      }
    },
  },
  methods: {
    log(selected_mock, question) {
      console.log(
        selected_mock,
        question,
        `https://localhost:3000/mocks/new?limit=50&neverSolved=false&mode=1&questionId=${question.id}`,
      );
    },
    print() {
      // Get HTML to print from element
      const prtHtml = document.getElementById("print").innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0",
      );

      const htmlstr = `<!DOCTYPE html>
            <html>
            <head>
                ${stylesHtml}
            </head>
            <body>
                ${prtHtml}
            </body>
            </html>`;

      WinPrint.document.write(htmlstr);
      WinPrint.document.close();

      const is_chrome = Boolean(WinPrint.chrome);
      if (is_chrome) {
        WinPrint.onload = function () {
          WinPrint.focus();
          WinPrint.print();
          WinPrint.close();
        };
      } else {
        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();
      }
    },
  },
};
</script>

<style>
.only-print {
  display: none !important;
}
.title-print {
  padding: 16px 0;
}
@media print {
  .only-print {
    display: flex !important;
  }
}
.question-alternative {
  line-break: auto !important;
  text-overflow: unset !important;
  white-space: normal !important;
  margin-bottom: 6px !important;
  font-size: 0.975rem !important;
}
@media print {
  .question-title {
    font-size: 16px !important;
    padding-bottom: 4px !important;
  }
}
</style>
